// extracted by mini-css-extract-plugin
export default {"badges":"OpportunityBadges_badges__TjRlU","badge_verified":"OpportunityBadges_badge_verified__KW2e8"};